import { CapabilityRuleStatus, CapabilityUnavailableBehavior, evaluateCapabilities, evaluateCapability, evaluateSubCapability, } from "@next-platform/packages-ts-types";
function convertToClientResolvedCapability(resolved, config) {
    const rule = config?.rule;
    const enabledRule = rule?.status === CapabilityRuleStatus.ENABLED ? rule : undefined;
    const subCapabilities = resolved.subCapabilities
        ? Object.entries(resolved.subCapabilities).reduce((accumulator, [subKey, subResolved]) => {
            if (subResolved) {
                accumulator[subKey] = convertToClientResolvedCapability(subResolved, config?.subCapabilities?.[subKey]);
            }
            return accumulator;
        }, {})
        : undefined;
    return {
        ...resolved,
        isPaywall: !resolved.allowed && resolved.unavailableBehavior === CapabilityUnavailableBehavior.SHOW_PAYWALL,
        requiredRoles: enabledRule?.gatedBy?.roles,
        requiredPermissions: enabledRule?.gatedBy?.permissions,
        paywallRoles: enabledRule?.paywallRoles,
        subCapabilities,
    };
}
export function resolveConfigForClient(capabilityKey, context, options) {
    const resolved = evaluateCapability(capabilityKey, context, options);
    if (!resolved) {
        return null;
    }
    return convertToClientResolvedCapability(resolved, context.applicationDefinition.capabilities[capabilityKey]);
}
export function evaluateClientSubCapability(capabilityKey, subCapabilityKey, context) {
    const resolved = evaluateSubCapability(capabilityKey, subCapabilityKey, context);
    if (!resolved) {
        return null;
    }
    const parentConfig = context.applicationDefinition.capabilities[capabilityKey];
    const subConfig = parentConfig?.subCapabilities?.[subCapabilityKey];
    return convertToClientResolvedCapability(resolved, subConfig);
}
export function evaluateClientCapabilities(applicationDefinition, viewer, featureFlags, platform) {
    const resolvedCapabilities = evaluateCapabilities(applicationDefinition, viewer, featureFlags, platform);
    const result = {};
    for (const key in resolvedCapabilities) {
        if (Object.prototype.hasOwnProperty.call(resolvedCapabilities, key)) {
            const capabilityKey = key;
            result[capabilityKey] = convertToClientResolvedCapability(resolvedCapabilities[capabilityKey], applicationDefinition.capabilities[capabilityKey]);
        }
    }
    return result;
}
